export default {
    common: {
        email: 'Email',
        LoginBtn: 'Accesso',
        SignUpBtn: 'Iscriviti',
        SubmitBtn: 'Confermare',
        ExitBtn: 'Lasciare',
        LogoutBtn: 'Disconnessione'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'Controlla la tua e-mail per il codice di verifica.',
        VerificationCode: 'Codice di verifica'
    },
    header: {
        OrderHistory: 'Storico ordini',
        MYACCOUNT: 'IL MIO ACCOUNT',
        WelcomeBack: 'Benvenuto'
    },
    detail: {
        TotalOrders: 'Totale ordini',
        TotalProducts: 'Totale prodotti',
        WonderlandPoints: 'Punti Wonderland',
        APMCredits: 'APM Crediti',
        ExpireOn: 'Scade il',
        NoAPMCredits: 'Nessun crediti APM',
        CreditsLoading: 'Caricamento crediti',
        Orders: 'Ordine',
        Online: 'Online',
        Boutique: 'Boutique',
        Total: 'Totale',
        Delivered: 'Consegnato',
        NoData: 'Nessun Dato',
        Status: 'Stato',
        item: 'articolo',
        items: 'articoli'
    },
    panel: {},
    entry: {
        Client: 'Cliente',
        OrderDate: `Data dell'ordine`,
        DeliverDate: 'Data di consegna',
        Description: 'Descrizione',
        Total: 'Totale'
    },
    board: {
        Order: 'ORDINE',
        Date: 'DATA',
        Total: 'TOTALE'
    },
    order: {
        OrderID: 'ID ordine',
        PurchasePlace: 'Luogo',
        PurchaseDate: `Data dell'ordine`,
        TotalPrice: 'Prezzo totale',
    },
    product: {
        Name: 'Nome',
        SKU: 'SKU',
        Size: 'Dimensione',
        Quantity: 'Quantità',
        Price: 'Prezzo',
        WarrantyUntil: 'Garantito fino a',
    },
    ordersLayout: {
            pageTitleOrders: "Ordini",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "Homepage",
            navProfile: "Profilo",
            navOrders: "Ordini",
            navWonderland: "Wonderland",
            navWishlist: "Lista desideri",
            navContactUs: "Contattaci",
            navExchangeReturn: "Cambio e reso",
            footerExchangePolicy: "Politica di cambio e reso",
            footerShipping: "Spedizione",
            footerPrivacy: "Informativa sulla privacy",
            footerTerms: "Termini di servizio",
            footerRegion: "Francia",
            menuTrackOrder: "Traccia ordine",
            menuViewDetails: "Vedi dettagli",
            back: "Indietro",
            orderNumberHeading: "Numero ordine {{id}}",
            itemsCount_one: "{{count}} articolo",
            itemsCount_other: "{{count}} articoli",
            emptyOrders: "Nessun ordine",
            invoiceSoon: "Disponibile a breve",
            storeAddressPending: "Indirizzo disponibile a breve",
            skuPrefix: "SKU",
            statusLabel: "Stato",
            productNameFallback: "Prodotto",
            tabOnline: "ONLINE",
            tabOffline: "OFFLINE",
            learnMore: "SCOPRI DI PIÙ",
            redeemInStore: "RISCATTA IN NEGOZIO",
            dateLabel: "Data",
            itemSingular: "Articolo",
            statusConfirmed: "Confermato il",
            purchaseDateLabel: "Data di acquisto:",
            monthJan: "Gen",
            monthFeb: "Feb",
            monthMar: "Mar",
            monthApr: "Apr",
            monthMay: "Mag",
            monthJun: "Giu",
            monthJul: "Lug",
            monthAug: "Ago",
            monthSep: "Set",
            monthOct: "Ott",
            monthNov: "Nov",
            monthDec: "Dic",
            storeLabel: "Negozio",
            downloadInvoice: "Scarica fattura",
            warrantyExpires: "Garanzia in scadenza il",
            sizeLabel: "Taglia",
            subtotalLabel: "Subtotale",
            totalLabel: "Totale",
        },
}


// WEBPACK FOOTER //
// ./src/locales/it/index.js